import {
  Command,
  CommandItem,
  Currency,
  DbType,
  Delivery,
  DeliveryLot,
  DocumentFormat,
  InvoiceItem,
  Patient,
  PatientLight,
  Permission,
  Product,
  Reference,
  ReferenceCategory,
  Service,
  TableName,
  TenderItem,
  TicketNumber,
  User,
  frequentRoles,
  frequentSnomedParents,
  referenceCategories,
} from "@/src/data/allTypes";
import "moment/locale/fr";
moment.locale("fr");

import moment from "moment";
import "moment/locale/fr";
import { Bounce, toast } from "react-toastify";
import { USER } from "../data/globalVariables";
moment.locale("fr");

export function getDbType() {
  return process.env.DB_TYPE as DbType;
}

export function getAge(patient: Patient | PatientLight | null | undefined) {
  if (!patient) return null;
  let years = moment().diff(moment(patient.birth), "years");
  let months = moment().diff(moment(patient.birth), "months");
  if (years < 1) return `${months} mois`;
  if (months < 1)
    return `${moment().diff(moment(patient.birth), "days")} jours`;
  return `${years} ans`;
}

export function getName(patient: Patient | null | undefined) {
  if (!patient) return null;
  return `${patient.lastName || ""} ${patient.firstName || ""}`;
}

export function getUserShortName(user: User | null | undefined) {
  if (!user) return null;
  if (typeof user != "object") return null;
  let firstName = user.firstName || "";
  let firstLetter = firstName[0] || "";
  return `${getGrade(user)} ${firstLetter}${firstLetter ? "." : ""} ${
    user.lastName || ""
  }`;
}

export function getUserFullName(user: User | null | undefined) {
  if (!user) return null;
  if (typeof user != "object") return null;
  return `${getGrade(user)} ${user.lastName || ""} ${user.firstName || ""}`;
}

export function getGrade(user: User | null | undefined) {
  if (!user) return "";
  if (isNurse(user) || isAdmin(user) || isReception(user)) return "";
  if (getItemId(user.role) == frequentRoles.technicien_anapath.id) return "";

  let grade = user.grade;
  if (grade == "Autre") return "";
  if (grade == "Pr") return "Pr";
  if (grade == "Dr") return "Dr";
  if (grade == "Résident") return "Dr";
  if (grade == "Interne") return "Dr";
  if (grade == "Assitant") return "Dr";
  if (grade == "MCA") return "Dr";
  if (grade == "MCB") return "Dr";
  if (grade == "Externe") return "";
  if (user.role?.name?.toLowerCase().includes("decin")) return "Dr";
  return user.grade || "Dr";
}

export function getExamCategoryName(
  categoryId: ReferenceCategory | null | undefined
) {
  if (!categoryId) return;
  let category = referenceCategories[categoryId];

  return category?.name || "";
}

export function getTotal(
  counts: Record<string, { date: string; count: number }> | undefined | null
) {
  if (!counts) return 0;
  let total = 0;
  for (const key in counts) {
    total += counts[key].count;
  }
  return total;
}

export function isCardiologist(user: User | null | undefined) {
  return user?.role?.name?.toLowerCase()?.includes("cardiologue");
}

export function isAdmin(user: User | null | undefined) {
  return (
    user?.id == "users:1709198699135q0fnhb8dr" ||
    getItemId(user?.role) == frequentRoles.administrateur.id ||
    user?.role?.name?.toLowerCase()?.includes("admin") ||
    user?.role?.name?.toLowerCase()?.includes("chef")
  );
}

export function isPharmacyAdmin(user: User | null | undefined) {
  return (
    isAdmin(user) ||
    getItemId(user?.role) == frequentRoles.administrateur.id ||
    user?.role?.name?.toLowerCase()?.includes("chef")
  );
}

export function isSuperAdmin(user: User | null | undefined) {
  return user?.role?.name?.toLowerCase()?.includes("super");
}

export function isNurse(user: User | null | undefined) {
  return (
    getItemId(user?.role) == frequentRoles.nurse.id ||
    ["infirmier", "nurse"].includes(user?.role?.name?.toLowerCase() || "none")
  );
}

export function isReception(user: User | null | undefined) {
  if (getItemId(user?.role) == frequentRoles.reception.id) return true;
  if (getItemId(user?.role) == frequentRoles.reception_urgences.id) return true;
  if (getItemId(user?.role) == frequentRoles.radiology_reception.id)
    return true;
  if (getItemId(user?.role) == frequentRoles["Secrétariat chef de service"].id)
    return true;

  let roleName = user?.role?.name?.toLowerCase() || "none";
  for (let str of ["reception", "accueil", "secr"]) {
    if (roleName.includes(str)) return true;
  }
  return false;
}

export function isBureauAdmission(user: User | null | undefined) {
  return USER.get()?.role?.name?.toLowerCase()?.includes("admission");
}

export function isHospital() {
  //@ts-ignore
  return process.env.IS_HOSPITAL === "true" || process.env.IS_HOSPITAL === true;
}

export function isCabinet() {
  //@ts-ignore
  return process.env.IS_HOSPITAL !== "true" && process.env.IS_HOSPITAL !== true;
}

export function getOptionsFromRecord(
  object: Record<string, { id: string; name: string }> | null | undefined
) {
  if (!object) return [];
  return Object.values(object).map((value) => {
    return { value: value.id, label: value.name };
  });
}

export function getShortPatientId(rawPatientId: string | null | undefined) {
  if (!rawPatientId) return null;

  let patientId = rawPatientId.split(":")[1];
  let firstAdditionalLetter = patientId.substring(13, 14);
  console.log("substring", patientId.substring(0, 13));
  return `${parseInt(patientId.substring(0, 13)).toString(
    36
  )}`;
}

export function cleanHtmlEscaping(content: string) {
  return content
    .replaceAll("&lt;", "<")
    .replaceAll("&gt;", ">")
    .replaceAll("<br>", "")
    .replaceAll("&amp;", "&")
    .replaceAll("&quot;", '"')
    .replaceAll("&apos;", "'")
    .replaceAll("&nbsp;", " ")
    .replaceAll("&middot;", "·")
    .replaceAll("&bull;", "•")
    .replaceAll("&hellip;", "…")
    .replaceAll("&ndash;", "–")
    .replaceAll("&mdash;", "—")
    .replaceAll("&lsquo;", "'")
    .replaceAll("&rsquo;", "’")
    .replaceAll("&rdquo;", "”")
    .replaceAll("&laquo;", "«")
    .replaceAll("&raquo;", "»");
}

export function generateNewId(
  oldId: string | number | null | undefined,
  table: TableName
): any {
  if (oldId === "" || oldId === null || oldId === undefined)
    return oldId?.toString();
  if (oldId?.toString().includes(`${table}:`)) return oldId;

  return `${table}:${
    btoa(unescape(encodeURIComponent(oldId?.toString() || ""))) || ""
  }`
    .replaceAll("=", "_")
    .replaceAll("+", "_")
    .replaceAll("/", "_");
}

export function escapeId(tableName: TableName, id: string | number) {
  if (!id) return "";
  id = id.toString();
  id = id.trim();
  id = id.replaceAll("è", "e");
  id = id.replaceAll(" ", "_");
  id = id.replaceAll("/", "_");
  id = id.replaceAll(":", "_");
  id = id.replaceAll(".", "_");
  id = id.replaceAll("-", "_");
  id = id.replaceAll("(", "_");
  id = id.replaceAll(")", "_");
  id = id.replaceAll("�", "_");
  id = id.replaceAll("*", "_");
  id = id.replaceAll("?", "_");
  id = id.replaceAll("!", "_");
  id = id.replaceAll(" ", "_");
  id = id.replaceAll(",", "_");
  id = id.replaceAll("'", "_");
  id = id.replaceAll(".", "_");
  id = id.replaceAll(";", "_");
  return `${tableName}:${id}`;
}

export function getOptionValueStr(value: any): string | null | undefined {
  if (Array.isArray(value)) return value.map(getOptionValueStr).join(",");
  if (typeof value == "object")
    return value.value?.toString() || value?.name?.toString() || "";
  return value?.toString();
}

export function printContent(
  html: string | null | undefined,
  format: DocumentFormat | null | undefined,
  service: Service | null | undefined
) {
  console.log("window.frames", window.frames);
  let frame = document.getElementById("printf");
  if (!frame)
    return openToast(
      "error",
      "Erreur lors de l'impression. Frame n'est pas défini"
    );
  frame.style.display = "block";

  //@ts-ignore
  var newWin = window.frames.printf;
  let baseUrl = window.location.href.split("/").slice(0, 3).join("/");

  html = `<base href="${baseUrl}/">	
                <link rel="stylesheet" href="${baseUrl}/styles/general.css" />
                <link rel="stylesheet" href="${baseUrl}/styles/index.css" />
                <body onload="window.print()" style="display:block;" class="format-${
                  format || ""
                } theme-${service?.theme || ""} themeColor-${
    service?.color
  }  shouldFixFooter">
                    ${html || ""}
                </body>`;
  newWin?.document.write(html);
  newWin?.document.close();
  frame.style.display = "none";
}

export function checkReferenceGuidelines(reference: Reference): boolean {
  if (!reference) return false;
  let name = (reference.name || "")?.toLowerCase();
  if (name.includes("+")) return false;
  if (name.includes(" et ")) return false;
  if (name.includes(" depuis ")) return false;
  if (name.includes(" . ")) return false;
  if (name.includes(" , ")) return false;
  return true;
}

export function getTicketNumberName(
  ticketNumber: TicketNumber | null | undefined
) {
  if (!ticketNumber) return "";
  let emergencyName = "";
  let level = ticketNumber.emergencyLevel;
  if (level == "notUrgent") emergencyName = "A";
  if (level == "urgent") emergencyName = "B";
  if (level == "veryUrgent") emergencyName = "C";
  return `N° ${emergencyName}${ticketNumber.prefix || ""}${
    ticketNumber.number
  }`;
}

export async function ajax(functionName: string, data: Record<any, any> | any) {
  // await simulateSlowNetwork(functionName, data, 40);

  let result = await fetch(`./api/${functionName}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data || {}), // body data type must match "Content-Type" header
  });

  let json = await result.json();
  if (json.error) throw new Error(json.error);
  // await simulateSlowNetwork(functionName, json, 100);
  return json;
}

async function simulateSlowNetwork(name: string, json: any, kbs: number) {
  if (process.env.NODE_ENV !== "development") return;
  let length = JSON.stringify(json)?.length;
  let kb = parseInt((length / 1024).toString());
  console.log(`${name?.replace("general/", "")} ${kb}KB`, json);
  await sleep((kb / kbs) * 1000);
}

export function getRemedType(): "REMED" | "FORENXPERT" | "ECG" | "ECRF" {
  return process.env.REMED_TYPE as any;
}

export function flutterPost(message: {
  type:
    | "help"
    | "request_token"
    | "request_notification_permission"
    | "close_app";
}) {
  (window as any)?.Flutter?.postMessage?.(JSON.stringify(message));
}

export function uid(): string {
  return getRandomString(14);
}

export function getRandomString(length: number) {
  return (Math.random() + 1).toString(36).substring(3, length + 3);
}

export function getRandomInt(length: number) {
  return parseInt((Math.random() + 1).toString().substring(3, length + 3));
}

export function jsonAbstract(value: any): any {
  if (!value) return value;
  return JSON.parse(JSON.stringify(value));
}

let DEBOUNCES: Record<string, NodeJS.Timeout> = {};
export function debounce(name: string, callback: () => void, duration: number) {
  try {
    clearTimeout(DEBOUNCES[name]);
  } catch (e) {}
  (DEBOUNCES as any)[name] = setTimeout(callback, duration);
}

export function stopDebounce(name: string) {
  try {
    clearTimeout(DEBOUNCES[name]);
  } catch (e) {}
}

export function fromNow(date: string | null | undefined): string | null {
  if (!date) return null;
  //more than a day
  if (moment().diff(moment(date), "days") > 1)
    return moment(date).format("LL à HH:mm");
  return moment(date).fromNow();
}

export function getDayCount(
  startDate: string | null | undefined,
  date: string | null | undefined
): string | null {
  if (!date || !startDate) return null;
  return `J${moment(date).diff(moment(startDate), "days")}`;
}

export function toBase64(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });
}

export async function sleep(delayInms: number) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(2);
    }, delayInms);
  });
}

export function openToast(
  type: "success" | "error" | "warning" | "info" = "success",
  content: any,
  onClick?: (() => void) | null | undefined,
  duration: number = 5000
) {
  toast[type]?.(content, {
    position: "bottom-center",
    autoClose: duration,
    hideProgressBar: false,
    closeOnClick: true,
    onClick: onClick || (() => {}),
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    style: { zIndex: 999999999 },

    transition: Bounce,
  });
}

export function rgbaToHex(color: string | null | undefined) {
  if (!color) return color;
  color = color.trim().toLowerCase();
  if (color.startsWith("rgba")) {
    let parts = color
      .replace("rgba(", "")
      .replace(")", "")
      .split(",")
      .map((part) => parseInt(part));
    return `#${parts[0].toString(16)}${parts[1].toString(
      16
    )}${parts[2].toString(16)}`;
  }
  return color;
}

export function colorToRgba(
  color: string | null | undefined,
  opacity: number = 1
) {
  if (!color) return color;
  color = color.trim().toLowerCase();
  if (color.startsWith("#")) {
    color = color.substring(1);
    let r = parseInt(color.substring(0, 2), 16);
    let g = parseInt(color.substring(2, 4), 16);
    let b = parseInt(color.substring(4, 6), 16);
    return `rgba(${r},${g},${b},${opacity})`;
  }

  if (color.startsWith("hsl")) {
    return color.replace("hsl", `hsla`).replace(")", `,${opacity})`);
  }
  if (color.startsWith("rgb")) {
    return color.replace("rgb", `rgba`).replace(")", `,${opacity})`);
  }
  if (color.startsWith("rgba")) {
    return color.replace(/,([^,]+)\)/, `,${opacity})`);
  }
  return color;
}

export function updateOrPush<T>(
  array: T[] | null | undefined,
  item: T,
  filterFunction?: (item: T) => boolean
): T[] {
  if (!array) array = [];

  let index = array.findIndex(
    filterFunction || ((i: any) => i?.["id"] === item?.["id" as keyof T])
  );

  if (index != -1) {
    array[index] = item;
  } else {
    array.push(item);
  }
  return array;
}

export function formatDate(
  date: string | null | undefined,
  format: "LL" | "LL HH:mm" | "LL à HH:mm" | "HH:mm"
) {
  if (!date) return "";
  let result = moment(date).format(format);
  if (result == "Invalid date") return "";
  return result;
}

export function isToday(date: string | null | undefined): boolean {
  if (!date) return false;
  return moment(date).format("YYYY-MM-DD") == moment().format("YYYY-MM-DD");
}

export function getFileType(
  name: string | null | undefined
): "image" | "file" | "dicom" | "video" | null {
  if (!name) return null;
  let parts = name.split(".");
  let extension = parts[parts.length - 1]?.toLowerCase();
  if (extension == "db") return "file";
  if (extension == "dcm" || extension == "dicom") return "dicom";
  if (["jpg", "jpeg", "png", "gif", "bmp", "svg", "webp"].includes(extension))
    return "image";
  if (["mp4", "avi", "mov", "mkv", "webm"].includes(extension)) return "video";
  return "file";
}

export function getImgUrl(
  upload: { name: string | null | undefined } | null | undefined
): string {
  const name = upload?.name;
  if (!name) return "";
  return `${getBackendUrl()}/my_uploads/${name}`;
}

export function getBackendUrl() {
  if (process.env.NODE_ENV == "development")
    return process.env.BACKEND_BASE_URL;
  return "";
}

export function getItemId(item: any) {
  if (!item) return null;
  if (typeof item == "string" || typeof item == "number") return item;
  return item.id;
}
export function removeIds(items: any): any {
  if (!items) return items;
  if (typeof items == "string" || typeof items == "number") return items;
  if (Array.isArray(items)) return items.map(removeIds);
  return { ...items, id: null };
}

export function getItemsIds(items: any[]) {
  if (!items) return [];
  if (!Array.isArray(items)) return [getItemId(items)];
  return items.map(getItemId);
}
export function itemsIncludeId(items: any, id: any): boolean {
  if (!items) return false;
  for (let item of items) {
    if (getItemId(item) != null && getItemId(item) == getItemId(id))
      return true;
  }
  return false;
}

export function isMobile() {
  if (typeof window == "undefined") return false;
  return window.innerWidth < 800;
}

export function decodeBase64(str: any) {
  if (!str) return str;
  return decodeURIComponent(
    atob(str)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
}

export function decodeAndParseBase64(
  str: any
): Record<any, any> | any[] | null {
  if (!str) return str;
  try {
    return JSON.parse(decodeBase64(str));
  } catch (e) {
    return null;
  }
}

export function encodeBase64(str: any) {
  if (!str) return str;
  if (typeof str == "object") str = JSON.stringify(str);
  return btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
      return String.fromCharCode(parseInt("0x" + p1, 16));
    })
  );
}

export function getUserId(): any {
  return USER.get()?.id;
}

export function getUserStructureUnit() {
  return getItemId(USER.get()?.structureUnit);
}

export function getServiceId(): any {
  return USER.get()?.service?.id;
}
export function getHospitalId(): any {
  return USER.get()?.service?.hospital?.id;
}

export function hasPermission(
  selectedPermission: Permission,
  user?: User | null | undefined
): boolean {
  user ||= USER.get();
  return (
    user?.role?.permissions?.some(
      (permission) => selectedPermission == permission
    ) || false
  );
}

export function getLocalStorageItem(key: string) {
  if (typeof window != "undefined") {
    return localStorage.getItem(key);
  }
  return null;
}

export function setLocalStorageItem(key: string, value: string) {
  if (typeof window != "undefined") {
    localStorage.setItem(key, value);
  }
  return null;
}

export function removeLocalStorageItem(key: string) {
  if (typeof window != "undefined") {
    localStorage.removeItem(key);
  }
  return null;
}

//add spaces every 3 digits
export function formatCurrency({
  value,
  currency = "DZD",
  type = "TTC",
  tva,
  showCurrency = true,
  showType = false,
  asString = false,
}: {
  value: number;
  currency: Currency | null | undefined;
  type: "TTC" | "HT" | "NONE";
  tva: number | null | undefined;
  showCurrency?: boolean;
  showType?: boolean;
  asString?: boolean;
}) {
  let newValue = value;
  if (type == "TTC" && tva)
    newValue = parseFloat(calculateTTC(value, tva).toFixed(2));

  let formattedValue = addSpacingToNumber(newValue);

  let formattedType = type == "NONE" || !showType ? "" : `${type}`;

  if (asString)
    return `${formattedValue} ${showCurrency ? currency : ""} ${formattedType}`;

  return (
    <div>
      <strong>{formattedValue}</strong>
      {showCurrency && <span className="gray normal"> {currency} </span>}
      <span className="gray"> {formattedType}</span>
    </div>
  );
}

export function simpleFormatPrice(value: number) {
  return formatCurrency({
    value: value,
    currency: "DZD",
    type: "TTC",
    showType: false,
    tva: 0,
    asString: true,
    showCurrency: false,
  });
}

export function addSpacingToNumber(value: number | null | undefined) {
  if (!value) return "0";
  return parseFloat(value.toString())
    .toFixed(2)
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export function addPaddingToNumber(
  value: number | null | undefined,
  padding: number
) {
  if (!value) return "0";
  return value.toString().padStart(padding, "0");
}

export function calculateTTC(value: number, tva: number) {
  return value * (1 + tva / 100);
}

export function isSecondaryPharmacy(user: User | null | undefined) {
  return user?.role?.name?.toLowerCase()?.includes(" de service");
}

export async function decodeStream({
  stream,
  parseChunk,
  onChunkReceived,
  onStreamComplete,
}: {
  stream: ReadableStream<any>;
  parseChunk?: (chunk: string) => string;
  onChunkReceived: (value: any, fullValue: any, parsedValue: any) => void;
  onStreamComplete: (fullValue: any, parsedValue: any) => void;
}) {
  if (!stream) return null;
  try {
    const reader = stream?.getReader();
    const decoder = new TextDecoder("utf-8");

    let fullValue = "";
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      let chunk = decoder.decode(value, { stream: true });
      if (parseChunk) chunk = parseChunk(chunk);
      fullValue += chunk;
      onChunkReceived(chunk, fullValue, parseIncompleteJson(fullValue));
    }
    onStreamComplete(fullValue, parseIncompleteJson(fullValue));
  } catch (e) {
    return null;
  }
}

export function parseOpenAiChunk(chunk: string) {
  if (!chunk) return null;
  console.log("gonna parse chunk", chunk);
  let parts = chunk.replaceAll("\n{", "\n{{").split("\n{");
  let partsStr = "";
  for (let part of parts) {
    partsStr += JSON.parse(part)?.choices?.[0]?.delta?.content || "";
  }
  return partsStr;
}

// export function parseOpenAiChunk(chunk: string) {
//   if (!chunk) return null;
//   console.log("gonna parse chunk", chunk);
//   let parts = chunk.replaceAll("\n{", "\n{{").split("\n{");
//   let partsStr = "";
//   for (let part of parts) {
//     partsStr += JSON.parse(part)?.choices?.[0]?.delta?.content || "";
//   }
//   return partsStr;
// }

export function parseIncompleteJson<T>(
  str: string | null | undefined
): T | null {
  if (!str) return null;
  let array: ("{" | "[" | '"')[] = [];
  let shouldIgnoreNext = false;
  for (let i = 0; i < str.length; i++) {
    let character = str[i];
    if (shouldIgnoreNext) {
      shouldIgnoreNext = false;
      continue;
    }

    if (character == "\\") {
      shouldIgnoreNext = true;
      continue;
    }

    if (character == '"' && array[array.length - 1] == '"') {
      array.pop();
      continue;
    }

    if (character == "}" && array[array.length - 1] == "{") {
      array.pop();
      continue;
    }

    if (character == "]" && array[array.length - 1] == "[") {
      array.pop();
      continue;
    }

    if (character == '"') array.push(character);

    if (character == "{") array.push(character);

    if (character == "[") array.push(character);
  }

  let newStr = str;
  for (let character of array.reverse()) {
    let closingMap = {
      "{": "}",
      "[": "]",
      '"': '"',
    };
    newStr += closingMap[character];
  }
  try {
    let parsed = JSON.parse(newStr);
    return parsed;
  } catch (e) {
    // console.log("error parsing json", { e, array, str, newStr });
    return null;
  }
}

export function shouldOpenInDrawer(reference: Reference) {
  if ((reference?.sections?.length || 0) > 1) return true;
  let fieldsCount = 0;
  for (let section of reference?.sections || []) {
    if (section?.type == "table") return true;
    for (let field of section?.fields || []) {
      if (field?.type == "upload") return true;
      fieldsCount++;
    }
  }
  if (fieldsCount > 6) return true;
  return false;
}

export function getExamCategory(
  exam: Reference | null | undefined
): ReferenceCategory {
  if (!exam) return "other";
  let name = exam.name;
  name ||= "";
  name = name?.toLowerCase();
  if (!name) return exam.category || "other";

  const concept = exam.snomedConcept;

  if (concept) {
    if (
      concept.synonyms?.toLowerCase().includes("ecg") ||
      concept.synonyms?.toLowerCase().includes("ekg") 
    )
      return "ecg";

    if (concept?.allParents?.includes(getItemId(frequentSnomedParents.labExam)))
      return "biology";
    if (concept?.allParents?.includes(getItemId(frequentSnomedParents.imaging)))
      return "imaging";

    if (
      concept?.allParents?.includes(
        getItemId(frequentSnomedParents.exploration)
      )
    )
      return "exploration";
  }
  if (name.includes("bilan")) return "biology";
  if (name.includes("iono")) return "biology";
  if (name.includes("fns")) return "biology";

  if (name.includes("coronaro")) return "imaging";
  if (name.includes("ecg")) return "ecg";
  if (name.includes("irm")) return "imaging";
  if (name.includes("chographie")) return "imaging";
  if (name.includes("doppler")) return "imaging";
  if (name.includes("scanner")) return "imaging";
  if (name.includes("tdm")) return "imaging";
  if (name.includes("ett")) return "imaging";
  return exam.category || "other";
}

export function getTenderItemsTotal({
  items,
  column,
  addTva = false,
}: {
  items: (TenderItem | null | undefined)[];
  addTva?: boolean;
  column:
    | "forcastedQuantity"
    | "minimumQuantity"
    | "maximumQuantity"
    | "commandedQuantity"
    | "commandedQuantity"
    | "deliveredQuantity";
}) {
  let count = 0;
  for (let item of items) {
    let quantity = item?.[column] || 0;
    let unitPrice = item?.unitPrice || 0;
    if (!quantity || !unitPrice) continue;
    let tva = getTVA({
      product: item?.product,
      commandItem: null,

      tenderItem: item,
    });
    if (addTva == false) tva = 0;

    let price =
      quantity *
      parseFloat((unitPrice || "0").toString()) *
      (1 + (tva || 0) / 100);

    count += price;
  }
  return count;
}

export function getTVA({
  product,
  deliveryLot,
  invoiceItem,
  commandItem,
  tenderItem,
}: {
  product: Product | null | undefined;
  deliveryLot?: DeliveryLot | null | undefined;
  invoiceItem?: InvoiceItem | null | undefined;
  commandItem: CommandItem | null | undefined;
  tenderItem: TenderItem | null | undefined;
}) {
  tenderItem ||= commandItem?.tenderItem;
  commandItem ||= invoiceItem?.commandItem;
  if (deliveryLot?.tva !== undefined && deliveryLot?.tva !== null)
    return deliveryLot.tva;
  if (invoiceItem?.tva !== undefined && invoiceItem?.tva !== null)
    return invoiceItem.tva;
  if (commandItem?.tva !== undefined && commandItem?.tva !== null)
    return commandItem.tva;
  if (tenderItem?.tva !== undefined && tenderItem?.tva !== null)
    return tenderItem.tva;
  return product?.tva || 0;
}

export function getCommandItemsTotal({
  items,
  addTva = false,
  column,
}: {
  items: (CommandItem | null | undefined)[];
  addTva?: boolean;
  column: "demandedQuantity" | "acceptedQuantity" | "receivedQuantity";
}) {
  let count = 0;
  for (let item of items) {
    let quantity = item?.[column] || 0;
    let unitPrice = item?.unitPrice || 0;
    if (!quantity || !unitPrice) continue;
    let tva = getTVA({
      product: item?.product,
      commandItem: item,
      tenderItem: null,
    });
    if (addTva == false) tva = 0;

    let price =
      quantity *
      parseFloat((unitPrice || "0").toString()) *
      (1 + (tva || 0) / 100);

    count += price;
  }
  return count;
}

export function getDeliveryLotsTotalPrice({
  command,
  deliveryLots,
  addTva = false,
}: {
  command: Command | null | undefined;
  deliveryLots: (DeliveryLot | null | undefined)[];
  addTva?: boolean;
}) {
  let count = 0;
  for (let deliveryLot of deliveryLots) {
    const commandItem = command?.commandedItems?.find(
      (item) => getItemId(item?.product) == getItemId(deliveryLot?.product)
    );

    let quantity = deliveryLot?.quantity || 0;
    let unitPrice =
      deliveryLot?.lot?.unitPrice || deliveryLot?.product?.price || 0;
    if (!quantity || !unitPrice) continue;
    let tva = getTVA({
      product: deliveryLot?.product,
      deliveryLot: deliveryLot,
      commandItem: commandItem,
      tenderItem: null,
    });

    if (addTva == false) tva = 0;

    let price =
      quantity *
      parseFloat((unitPrice || "0").toString()) *
      (1 + (tva || 0) / 100);

    count += price;
  }
  return count;
}
export function getInvoiceItemsTotal({
  items,
  addTva = false,
  column,
}: {
  items: (InvoiceItem | null | undefined)[];
  addTva?: boolean;
  column: "quantity";
}) {
  let count = 0;
  for (let item of items) {
    let quantity = item?.[column] || 0;
    let unitPrice = item?.unitPrice || 0;
    if (!quantity || !unitPrice) continue;
    let tva = getTVA({
      product: item?.product,
      invoiceItem: item,
      commandItem: null,
      tenderItem: null,
    });
    if (addTva == false) tva = 0;

    let price =
      quantity *
      parseFloat((unitPrice || "0").toString()) *
      (1 + (tva || 0) / 100);

    count += price;
  }
  return count;
}

export function getProductNameStr(
  product:
    | { name?: string | null | undefined; code?: string | null | undefined }
    | null
    | undefined
) {
  if (!product) return "";
  return ` ${product.code || ""} - ${product.name || ""}`;
}

export function productNameContains(
  product:
    | {
        name?: string | null | undefined;
        code?: string | null | undefined;
      }
    | null
    | undefined,
  searchKey: string | null | undefined
) {
  if (!searchKey) return true;
  if (!product) return false;
  return getProductNameStr(product)
    .toLowerCase()
    .includes(searchKey.toLowerCase());
}

export function getUniqueDeliveryProducts({
  delivery,
  additionalProducts,
}: {
  delivery: Delivery;
  additionalProducts: Product[] | null | undefined;
}) {
  let products: Product[] = [];
  for (const commandItem of delivery.command?.commandedItems || []) {
    let product = commandItem?.product;
    if (!product) continue;
    if (typeof product == "string") continue;

    const alreadyAdded = products.find(
      (item) => getItemId(item) == getItemId(product)
    );
    if (alreadyAdded) continue;
    products.push(product);
  }
  for (const invoiceItem of delivery.invoice?.items || []) {
    let product = invoiceItem?.product;
    if (!product) continue;
    if (typeof product == "string") continue;

    const alreadyAdded = products.find(
      (item) => getItemId(item) == getItemId(product)
    );
    if (alreadyAdded) continue;
    products.push(product);
  }

  for (const deliveryLot of delivery.receivedLots) {
    if (!deliveryLot) continue;
    let product = deliveryLot?.product || deliveryLot?.lot?.product;
    if (!product) continue;
    // if (typeof product == "string") continue;
    const alreadyAdded = products.find(
      (item) => getItemId(item) == getItemId(product)
    );
    if (alreadyAdded) continue;
    products.push(product);
  }

  for (const product of additionalProducts || []) {
    const alreadyAdded = products.find(
      (item) => getItemId(item) == getItemId(product)
    );
    if (typeof product == "string") continue;

    if (alreadyAdded) continue;
    products.push(product);
  }
  return products;
}

export function getStructureUnit(user: User | null | undefined) {
  if (!user) return null;
  return user.service?.units?.find(
    (item) => getItemId(item) === getItemId(user.structureUnit)
  );
}

export function getUserProductGeneralCategories(user: User | null | undefined) {
  if (!user) return null;
  return getStructureUnit(user)?.generalCategories || [];
}

export function shouldShowVentilation(user: User | null | undefined) {
  if (!user) return false;
  let serviceName = user.service?.name?.toLowerCase();
  if (serviceName?.includes("réanim")) return true;
  if (serviceName?.includes("reanim")) return true;
  if (serviceName?.includes("uro")) return true;
  if (serviceName?.includes("orl")) return true;
  if (serviceName?.includes("chirurg")) return true;
  return false;
}
